// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dispatchName[data-v-33c4640b] {\n  width: 100%;\n  height: 39px;\n  border: 1px solid #dbdee5;\n  padding-left: 10px;\n  text-align: left;\n  border-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
